import { SummaryReportController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the summary reports for the given data.
 * @example
 * ```html
 * <salaxy-summary-report data="$ctrl.data"></salaxy-summary-report>
 * ```
 */
export class SummaryReport extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** The data for the report. */
      data: "<"
    };

    /** Uses the SummaryReportController */
    public controller = SummaryReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/SummaryReport.html";

}
